import { Copy, Check } from 'lucide-react';
import { useState } from 'react';
import { useSelector } from 'react-redux';

/**
 * ShareCodeDisplaySimple - Simplified share code display with copy button only
 * Used in help menus and other places where editing is not needed
 */
export default function ShareCodeDisplaySimple() {
  const user = useSelector((s) => s.user.profile);
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const shareCode = user?.share_code || '';
    if (shareCode) {
      navigator.clipboard.writeText(shareCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="flex items-center gap-1.5 rounded-xl border border-border bg-secondary/50 px-3 py-2">
      <span className="text-muted-foreground font-medium text-sm">@</span>
      <span className="text-sm font-medium">{user?.share_code || 'your.nametag'}</span>
      <button
        onClick={handleCopy}
        className="ml-1 flex h-6 w-6 items-center justify-center rounded-full bg-primary/10 text-primary hover:bg-primary/20 transition-colors"
        title="Copy share code"
      >
        {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
      </button>
    </div>
  );
}
